import Image from "next/image";
import Link from "next/link";
import { getAuthorByReference } from "../lib/authors";

const Author = (props) => {
	const author = getAuthorByReference(props.author || props.authorId || props.authorVariable);

	if (!author || author.id === "redakcja") {
		return null;
	}

	const ariaLabel = `Czytaj więcej o autorze ${author.name}`;

	return (
		<div className="pd-author">
			<div className="pd-author__image">
				<Image
					unoptimized
					alt=""
					src={author.image}
					width="740"
					height="740"
					quality={100}
					priority
					style={{
						width: "100%",
						height: "auto",
					}}
				/>
			</div>

			<header className="pd-author__header">
				<h3 className="pd-author__title">
					<Link href={author.path} aria-label={ariaLabel}>
						{author.name}
					</Link>
				</h3>
			</header>

			<p className="pd-author__description">{author.description}</p>

			<footer className="pd-author__footer">
				<Link href={author.path} aria-label={ariaLabel} className="pd-author__readmore">
					Czytaj więcej
				</Link>
			</footer>
		</div>
	);
};

export default Author;
